<template>
  <transition name="fade">
    <v-card
      v-show="isLoading"
      class="loading-card"
      :width="$vuetify.breakpoint.mdAndUp ? '300px' : undefined"
    >
      <template
        v-if="isOnlyLoadingShown"
      >
        <v-progress-linear
          active
          :indeterminate="isLoading"
          color="primary"
          absolute
          top
        />
        <div class="d-flex align-center pr-2 py-4">
          <div
            class="d-flex align-center justify-center"
            style="width:64px; height:64px;"
          >
            <v-progress-circular
              size="40"
              color="primary"
              indeterminate
            />
          </div>
          <div
            class="fs-14 font-weight-medium"
            style="width: calc(100% - 64px);"
          >
            We're still working to find you even more prices!
          </div>
        </div>
      </template>

      <template
        v-else
      >
        <v-progress-linear
          active
          :indeterminate="isLoading"
          :color="isLoading ? 'primary' : 'success'"
          absolute
          top
        />
        <div class="d-flex align-center pr-2 py-4">
          <div
            class="d-flex align-center justify-center"
            style="width:64px; height:64px;"
          >
            <v-progress-circular
              v-if="isLoading"
              size="40"
              color="primary"
              indeterminate
            />
            <v-icon
              v-if="!isLoading"
              color="success"
              size="40"
            >
              mdi-check
            </v-icon>
          </div>
          <div
            class="fs-14 font-weight-medium"
            style="width: calc(100% - 64px);"
          >
            <span v-if="isLoading">
              We're still working to find you even more prices!
            </span>
            <span v-else>
              Searching complete, we've found you prices from {{ totalcount }} insurance providers
            </span>
          </div>
        </div>
      </template>
    </v-card>
  </transition>
</template>

<script>
export default {
  name: 'loading-notice',
  props: {
    isOnlyLoadingShown: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    totalcount: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .loading-card {
    position: fixed;
    bottom: 0;
    right: 0;
    margin: 2em;
  }

  .fade-enter-active {
    transition: all 0.3s ease;
  }

  .fade-leave-active {
    transition-delay: 3s;
  }
</style>
